import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getSsoDraftByAccountId} from 'src/openapi/admin/apis/SsoDraftsApi';
import {useAppDispatch} from 'src/store/hooks';

import type {SsoDraft} from 'src/openapi/admin/models/SsoDraft';

export const useGetSsoDraft = (accountId: number) => {
    const dispatch = useAppDispatch();
    const getDispatchAction = useCallback(
        (signal: AbortSignal) => dispatch(getSsoDraftByAccountId({accountId}, {signal})),
        [accountId, dispatch],
    );

    return useReadOnlyDataHook<SsoDraft | null>({
        getDispatchAction,
        initValue: null,
        shouldLoadData: accountId > 0,
    });
};
